module.exports = __webpack_public_path__ + "static/media/4.34a995d4.svg";